import { FC } from 'react';
import { useTranslation } from '@hooks/useTranslation';
import { DailySiteReportSummary } from '@models/dailySiteReport.model';
import { TriggerChip } from './TriggerChip';
import { EmailStatusChip } from './EmailStatusChip';

interface ReportListItemProps {
  report: DailySiteReportSummary;
  onPress: () => void;
}

const pluralLabel = (count: number, singular: string, plural: string) => (count === 1 ? singular : plural);

export const ReportListItem: FC<ReportListItemProps> = ({ report, onPress }) => {
  const t = useTranslation('dailySiteReport');
  const c = report.counts;
  return (
    <button
      type="button"
      onClick={onPress}
      className="w-full text-left flex items-center justify-between gap-4 px-4 py-3 border-b border-gray-200 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-900">
      <div className="flex items-center gap-3">
        <span className="text-sm font-medium text-gray-900 dark:text-white">
          {new Date(`${report.localDate}T12:00:00`).toLocaleDateString(undefined, {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
          })}
        </span>
        <TriggerChip trigger={report.trigger} />
        <EmailStatusChip status={report.emailStatus} />
      </div>
      <span className="text-xs text-gray-500 dark:text-gray-400">
        {c.statusChanges} {pluralLabel(c.statusChanges, t.countStatusChangesLabelSingular, t.countStatusChangesLabel)} ·{' '}
        {c.incidents} {pluralLabel(c.incidents, t.countIncidentsLabelSingular, t.countIncidentsLabel)} · {c.documents}{' '}
        {pluralLabel(c.documents, t.countDocumentsLabelSingular, t.countDocumentsLabel)}
      </span>
    </button>
  );
};

export default ReportListItem;
